import { render, staticRenderFns } from "./ViqqaCallback.vue?vue&type=template&id=77d2aeeb"
import script from "./ViqqaCallback.vue?vue&type=script&lang=js"
export * from "./ViqqaCallback.vue?vue&type=script&lang=js"
import style0 from "./ViqqaCallback.vue?vue&type=style&index=0&id=77d2aeeb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports